module.exports = __webpack_public_path__ + "static/media/preBackground.615e0afd.png";